document.addEventListener("DOMContentLoaded", function(event) {

  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  let dataVariant = document.querySelector('[data-variant]');
  if (sizeParam) {
    document.querySelectorAll('[data-block-type="product-variations"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      var varAvailable = link.getAttribute('data-size-available-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
      if(varAvailable == 'false') {
        link.classList.add('is-disabled')
      } else {
        link.classList.remove('is-disabled')
      }
    }); 
    let productInfo = document.querySelector('.shopify-section--main-product .product-info');
    if (productInfo) {
      productInfo.querySelector('variant-picker').removeAttribute('force_unselected')
      productInfo.querySelector('product-form').removeAttribute('force_unselected')
    }
  } 

  let disabledAddToCartButtons = document.querySelectorAll('product-form[force_unselected] .buy-buttons button[type="button"]');
  if (disabledAddToCartButtons) {
    disabledAddToCartButtons.forEach(disabledAddToCartButton => {
      disabledAddToCartButton.addEventListener('click', (event) => {

        let disabledAlertExisting = document.querySelector('[option-name="Size"] .disabled-alert');
        let sizeLabel = document.querySelector('[option-name="Size"] legend + span');
        console.log(disabledAlertExisting);
        if (disabledAlertExisting) {
          disabledAlertExisting.remove();
        }
        let disabledAlert = document.createElement('div');
        disabledAlert.classList.add('disabled-alert','text-on-sale');
        disabledAlert.textContent = 'Please select a size';

        sizeLabel.after(disabledAlert);
        
      });

    });
    
  }

  let variantPickerOptions = document.querySelectorAll('variant-picker .variant-picker__option-values label');
  variantPickerOptions.forEach(variantPickerOption => {
    variantPickerOption.addEventListener('click', (event) => {
      let closestProductInfo = event.target.closest('.product-info');
      if (closestProductInfo) {
        closestProductInfo.querySelector('variant-picker').removeAttribute('force_unselected')
        closestProductInfo.querySelector('product-form').removeAttribute('force_unselected')
      }
    });
  });

  let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
  productCardColors.forEach(productCardColor => {
    productCardColor.addEventListener('click', (event) => {
      let closestProductCard = event.target.closest('product-card');
      let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
      thisProductCardColors.forEach(thisProductCardColor => {
        if (thisProductCardColor != event.target) {
          thisProductCardColor.previousElementSibling.checked = false;
          thisProductCardColor.classList.remove('is-selected');
        }
      });
      if (closestProductCard) {
        if (productCardColor.hasAttribute('data-sibling-product-image')) {
          let main_image = closestProductCard.querySelector('.product-card__image--primary');
          let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

          var newImageElement = document.createElement('img');
          newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
          newImageElement.setAttribute('width', '1200px');
          newImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-image'));

          var newAltImageElement = document.createElement('img');
          newAltImageElement.className = 'product-card__image product-card__image--secondary aspect-square';
          newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-alt-image'));
          
          closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
          closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
        }

        var siblingHandle = productCardColor.getAttribute('data-sibling-handle');
        var siblingUrl = productCardColor.getAttribute('data-sibling-url');
        var siblingTitle = productCardColor.getAttribute('data-sibling-title');
        var siblingTitle2 = productCardColor.getAttribute('data-sibling-title-2');
        var siblingPrice = productCardColor.getAttribute('data-sibling-price');
        var siblingComparePrice = productCardColor.getAttribute('data-sibling-compare-price');
        var siblingFullPrice = productCardColor.getAttribute('data-sibling-full-price');
        var siblingAvailable = productCardColor.getAttribute('data-sibling-available');

        if (siblingFullPrice == "true") {
          closestProductCard.classList.remove("sale");
          closestProductCard.classList.add("full");
        } else {
          closestProductCard.classList.remove("full");
          closestProductCard.classList.add("sale");
        }
        if (siblingAvailable == "true") {
          closestProductCard.classList.remove("sold-out");
          closestProductCard.classList.add("available");
        } else {
          closestProductCard.classList.remove("available");
          closestProductCard.classList.add("sold-out");
        }
        closestProductCard.setAttribute('handle', siblingHandle);
        closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', siblingUrl);
        closestProductCard.querySelector('.product-card__info .product-title .text').innerHTML = siblingTitle;
        if (siblingTitle2) {
          closestProductCard.querySelector('.product-card__info .product-title .text-subdued').innerHTML = siblingTitle2;
        }
        closestProductCard.querySelector('.product-card__info sale-price').innerHTML = siblingPrice;
        closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = siblingComparePrice;
      }
    });
  });

  const mainCollection = document.querySelector('.shopify-section--main-collection');
  if (mainCollection) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
          productCardColors.forEach(productCardColor => {
            productCardColor.addEventListener('click', (event) => {
              let closestProductCard = event.target.closest('product-card');
              let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
              thisProductCardColors.forEach(thisProductCardColor => {
                if (thisProductCardColor != event.target) {
                  thisProductCardColor.previousElementSibling.checked = false;
                  thisProductCardColor.classList.remove('is-selected');
                }
              });
              if (closestProductCard) {
                if (productCardColor.hasAttribute('data-sibling-product-image')) {
                  let main_image = closestProductCard.querySelector('.product-card__image--primary');
                  let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                  var newImageElement = document.createElement('img');
                  newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
                  newImageElement.setAttribute('width', '1200px');
                  newImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-image'));

                  var newAltImageElement = document.createElement('img');
                  newAltImageElement.className = 'product-card__image product-card__image--secondary aspect-square';
                  newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-alt-image'));
                  
                  closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                  closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                }

                var siblingHandle = productCardColor.getAttribute('data-sibling-handle');
                var siblingUrl = productCardColor.getAttribute('data-sibling-url');
                var siblingTitle = productCardColor.getAttribute('data-sibling-title');
                var siblingTitle2 = productCardColor.getAttribute('data-sibling-title-2');
                var siblingPrice = productCardColor.getAttribute('data-sibling-price');
                var siblingComparePrice = productCardColor.getAttribute('data-sibling-compare-price');
                var siblingFullPrice = productCardColor.getAttribute('data-sibling-full-price');
                var siblingAvailable = productCardColor.getAttribute('data-sibling-available');

                if (siblingFullPrice == "true") {
                  closestProductCard.classList.remove("sale");
                  closestProductCard.classList.add("full");
                } else {
                  closestProductCard.classList.remove("full");
                  closestProductCard.classList.add("sale");
                }
                if (siblingAvailable == "true") {
                  closestProductCard.classList.remove("sold-out");
                  closestProductCard.classList.add("available");
                } else {
                  closestProductCard.classList.remove("available");
                  closestProductCard.classList.add("sold-out");
                }
                closestProductCard.setAttribute('handle', siblingHandle);
                closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', siblingUrl);
                closestProductCard.querySelector('.product-card__info .product-title').innerHTML = siblingTitle;
                if (siblingTitle2) {
                  closestProductCard.querySelector('.product-card__info .product-title .text-subdued').innerHTML = siblingTitle2;
                }
                closestProductCard.querySelector('.product-card__info sale-price').innerHTML = siblingPrice;
                closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = siblingComparePrice;
              }
            });
          });
        }
      }
    });

    const config = { childList: true };
    observer.observe(mainCollection, config);
  }

  const relatedProducts = document.querySelector('.shopify-section--related-products product-recommendations');
  if (relatedProducts) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
          productCardColors.forEach(productCardColor => {
            productCardColor.addEventListener('click', (event) => {
              let closestProductCard = event.target.closest('product-card');
              let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
              thisProductCardColors.forEach(thisProductCardColor => {
                if (thisProductCardColor != event.target) {
                  thisProductCardColor.previousElementSibling.checked = false;
                  thisProductCardColor.classList.remove('is-selected');
                }
              });
              if (closestProductCard) {
                if (productCardColor.hasAttribute('data-sibling-product-image')) {
                  let main_image = closestProductCard.querySelector('.product-card__image--primary');
                  let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                  var newImageElement = document.createElement('img');
                  newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
                  newImageElement.setAttribute('width', '1200px');
                  newImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-image'));

                  var newAltImageElement = document.createElement('img');
                  newAltImageElement.className = 'product-card__image product-card__image--secondary aspect-square';
                  newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-alt-image'));
                  
                  closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                  closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                }

                var siblingHandle = productCardColor.getAttribute('data-sibling-handle');
                var siblingUrl = productCardColor.getAttribute('data-sibling-url');
                var siblingTitle = productCardColor.getAttribute('data-sibling-title');
                var siblingTitle2 = productCardColor.getAttribute('data-sibling-title-2');
                var siblingPrice = productCardColor.getAttribute('data-sibling-price');
                var siblingComparePrice = productCardColor.getAttribute('data-sibling-compare-price');
                var siblingFullPrice = productCardColor.getAttribute('data-sibling-full-price');
                var siblingAvailable = productCardColor.getAttribute('data-sibling-available');

                if (siblingFullPrice == "true") {
                  closestProductCard.classList.remove("sale");
                  closestProductCard.classList.add("full");
                } else {
                  closestProductCard.classList.remove("full");
                  closestProductCard.classList.add("sale");
                }
                if (siblingAvailable == "true") {
                  closestProductCard.classList.remove("sold-out");
                  closestProductCard.classList.add("available");
                } else {
                  closestProductCard.classList.remove("available");
                  closestProductCard.classList.add("sold-out");
                }
                closestProductCard.setAttribute('handle', siblingHandle);
                closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', siblingUrl);
                closestProductCard.querySelector('.product-card__info .product-title .text').innerHTML = siblingTitle;
                if (siblingTitle2) {
                  closestProductCard.querySelector('.product-card__info .product-title .text-subdued').innerHTML = siblingTitle2;
                }
                closestProductCard.querySelector('.product-card__info sale-price').innerHTML = siblingPrice;
                closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = siblingComparePrice;
              }
            });
          });
        }
      }
    });

    const config = { childList: true };
    observer.observe(relatedProducts, config);
  }

  const mainSearch = document.querySelector('.shopify-section--main-search #collection');
  if (mainSearch) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(() => {
            let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
            productCardColors.forEach(productCardColor => {
              productCardColor.addEventListener('click', (event) => {
                let closestProductCard = event.target.closest('product-card');
                let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
                thisProductCardColors.forEach(thisProductCardColor => {
                  if (thisProductCardColor != event.target) {
                    thisProductCardColor.previousElementSibling.checked = false;
                    thisProductCardColor.classList.remove('is-selected');
                  }
                });
                if (closestProductCard) {
                  if (productCardColor.hasAttribute('data-sibling-product-image')) {
                    let main_image = closestProductCard.querySelector('.product-card__image--primary');
                    let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                    var newImageElement = document.createElement('img');
                    newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
                    newImageElement.setAttribute('width', '1200px');
                    newImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-image'));

                    var newAltImageElement = document.createElement('img');
                    newAltImageElement.className = 'product-card__image product-card__image--secondary aspect-square';
                    newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-alt-image'));
                    
                    closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                    closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                  }

                  var siblingHandle = productCardColor.getAttribute('data-sibling-handle');
                  var siblingUrl = productCardColor.getAttribute('data-sibling-url');
                  var siblingTitle = productCardColor.getAttribute('data-sibling-title');
                  var siblingTitle2 = productCardColor.getAttribute('data-sibling-title-2');
                  var siblingPrice = productCardColor.getAttribute('data-sibling-price');
                  var siblingComparePrice = productCardColor.getAttribute('data-sibling-compare-price');
                  var siblingFullPrice = productCardColor.getAttribute('data-sibling-full-price');
                  var siblingAvailable = productCardColor.getAttribute('data-sibling-available');

                  if (siblingFullPrice == "true") {
                    closestProductCard.classList.remove("sale");
                    closestProductCard.classList.add("full");
                  } else {
                    closestProductCard.classList.remove("full");
                    closestProductCard.classList.add("sale");
                  }
                  if (siblingAvailable == "true") {
                    closestProductCard.classList.remove("sold-out");
                    closestProductCard.classList.add("available");
                  } else {
                    closestProductCard.classList.remove("available");
                    closestProductCard.classList.add("sold-out");
                  }
                  closestProductCard.setAttribute('handle', siblingHandle);
                  closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', siblingUrl);
                  closestProductCard.querySelector('.product-card__info .product-title .text').innerHTML = siblingTitle;
                  if (siblingTitle2) {
                    closestProductCard.querySelector('.product-card__info .product-title .text-subdued').innerHTML = siblingTitle2;
                  }
                  closestProductCard.querySelector('.product-card__info sale-price').innerHTML = siblingPrice;
                  closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = siblingComparePrice;
                }
              });
            });
          }, 2000);
        }
      }
    });

    const config = { childList: true };
    observer.observe(mainSearch, config);
  }

  const predictiveSearch = document.querySelector('#predictive-search');
  if (predictiveSearch) {
    const predictiveSearchShadowRoot = predictiveSearch.shadowRoot;
    if (predictiveSearchShadowRoot) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            let productCardColors = document.querySelectorAll('product-card .product-card__swatch-list label.color-swatch');
            productCardColors.forEach(productCardColor => {
              productCardColor.addEventListener('click', (event) => {
                let closestProductCard = event.target.closest('product-card');
                let thisProductCardColors = closestProductCard.querySelectorAll('.product-card__swatch-list label.color-swatch');
                thisProductCardColors.forEach(thisProductCardColor => {
                  if (thisProductCardColor != event.target) {
                    thisProductCardColor.previousElementSibling.checked = false;
                    thisProductCardColor.classList.remove('is-selected');
                  }
                });
                if (closestProductCard) {
                  if (productCardColor.hasAttribute('data-sibling-product-image')) {
                    let main_image = closestProductCard.querySelector('.product-card__image--primary');
                    let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

                    var newImageElement = document.createElement('img');
                    newImageElement.className = 'product-card__image product-card__image--primary aspect-square';
                    newImageElement.setAttribute('width', '1200px');
                    newImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-image'));

                    var newAltImageElement = document.createElement('img');
                    newAltImageElement.className = 'product-card__image product-card__image--secondary aspect-square';
                    newAltImageElement.setAttribute('src', productCardColor.getAttribute('data-sibling-product-alt-image'));
                    
                    closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
                    closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
                  }

                  var siblingHandle = productCardColor.getAttribute('data-sibling-handle');
                  var siblingUrl = productCardColor.getAttribute('data-sibling-url');
                  var siblingTitle = productCardColor.getAttribute('data-sibling-title');
                  var siblingTitle2 = productCardColor.getAttribute('data-sibling-title-2');
                  var siblingPrice = productCardColor.getAttribute('data-sibling-price');
                  var siblingComparePrice = productCardColor.getAttribute('data-sibling-compare-price');
                  var siblingFullPrice = productCardColor.getAttribute('data-sibling-full-price');
                  var siblingAvailable = productCardColor.getAttribute('data-sibling-available');

                  if (siblingFullPrice == "true") {
                    closestProductCard.classList.remove("sale");
                    closestProductCard.classList.add("full");
                  } else {
                    closestProductCard.classList.remove("full");
                    closestProductCard.classList.add("sale");
                  }
                  if (siblingAvailable == "true") {
                    closestProductCard.classList.remove("sold-out");
                    closestProductCard.classList.add("available");
                  } else {
                    closestProductCard.classList.remove("available");
                    closestProductCard.classList.add("sold-out");
                  }
                  closestProductCard.setAttribute('handle', siblingHandle);
                  closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', siblingUrl);
                  closestProductCard.querySelector('.product-card__info .product-title .text').innerHTML = siblingTitle;
                  if (siblingTitle2) {
                    closestProductCard.querySelector('.product-card__info .product-title .text-subdued').innerHTML = siblingTitle2;
                  }
                  closestProductCard.querySelector('.product-card__info sale-price').innerHTML = siblingPrice;
                  closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = siblingComparePrice;
                }
              });
            });
          }
        }
      });

      const config = { childList: true };
      observer.observe(predictiveSearchShadowRoot, config);
    }
  }
  
});


document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option2.replace(/\s/g, "").toLowerCase();
  document.querySelectorAll('[data-block-type="product-variations"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    var varAvailable = link.getAttribute('data-size-available-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
    if(varAvailable == 'false') {
      link.classList.add('is-disabled')
    } else {
      link.classList.remove('is-disabled')
    }
  });  

  let closestProductInfo = event.target.closest('.product-info');
  if (closestProductInfo) {
    closestProductInfo.querySelector('variant-picker').removeAttribute('force_unselected')
    closestProductInfo.querySelector('product-form').removeAttribute('force_unselected')
  }
});

document.addEventListener('change', function(event) {
  if (event.target.classList.contains('cross-sell_select')) {
    const productForm = event.target.closest('product-form');
    if (productForm) {
      const idInput = productForm.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = event.target.value;
      }
    }
  }
});